module.exports = __webpack_public_path__ + "static/media/SAT2.0535bfa1.ico";